// extracted by mini-css-extract-plugin
export default {"box":"Loading_box__-uJFk","spinner":"Loading_spinner__s5eU9","spinner-y0fdc1":"Loading_spinner-y0fdc1__cfJyI"};